const prodUrl = 'https://quiet-ridge-83792.herokuapp.com/api';
const testUrl = 'http://localhost:5000/api';

export const baseUrl = prodUrl;